import {useMatchMedia} from '@pexip/hooks';

import {SM_UP} from '../../constants/mediaQueries';

export const useSmUp = () => useMatchMedia(SM_UP);
